import React, { useContext } from "react";
import { FormattedMessage } from "react-intl";

import { ProductionContext } from "@/contexts/production";
import { JobQueueContext } from "@/views/production/orders/job-queue-provider";

export const MachineGroupStatusMessage = (): React.JSX.Element | string => {
	const { currentMachineGroup } = useContext(ProductionContext);
	const { selectedBatches } = useContext(JobQueueContext);

	switch (currentMachineGroup?.status) {
		case "Initializing":
			return <FormattedMessage id="Machine Initializing" defaultMessage="Machine Initializing" />;
		case "Service":
		case "MachineService": // @deprecated does this exist?
			return <FormattedMessage id="Machine is in Service Mode" defaultMessage="Machine is in Service Mode" />;
		case "Error":
			return <FormattedMessage id="Machine Error" defaultMessage="Machine Error" />;
		case "ChangingCorrugate":
			return <FormattedMessage id="Machine is Changing Corrugate" defaultMessage="Machine is changing Z-Fold" />;
		case "Paused":
			return <FormattedMessage id="Machine Paused" defaultMessage="Machine Paused" />;
		case "Offline":
			return <FormattedMessage id="Machine Offline" defaultMessage="Machine Offline" />;
		case "NoMachinesConfigured":
			return (
				<FormattedMessage id="No Configured Machines" defaultMessage="Machine groups has no configured machines" />
			);
		case "AirplaneMode":
			return <FormattedMessage id="Offline Operation Mode" defaultMessage="Offline Operation Mode" />;
		case "Online":
			if (currentMachineGroup?.productionEnabled) {
				if (selectedBatches?.length > 0) {
					return (
						<FormattedMessage
							id="Producing on {machineGroupName} ({count})"
							defaultMessage="Producing on {machineGroupName} ({count})"
							values={{ machineGroupName: currentMachineGroup.alias, count: selectedBatches?.length || 0 }}
						/>
					);
				} else {
					return <FormattedMessage id="Ready to Receive Jobs" defaultMessage="Ready to Receive Jobs" />;
				}
			} else {
				return (
					<FormattedMessage
						id="Press Play on the Status Bar to Produce"
						defaultMessage="Press Play on the Status Bar to Produce"
					/>
				);
			}
		default:
			return `State ${currentMachineGroup?.status} not handled`;
	}
};
